import { ActionTypes } from "../constants/action-types";

const initialState = {
  byTopic: {}  // { [topicName]: { authorName, imageUrl } }
};

export function UploadBlogImage(state = initialState, { type, payload }) {
  switch (type) {
    case ActionTypes.UPLOAD_BLOG_IMAGE:
      return {
        ...state,
        byTopic: {
          ...state.byTopic,
          [payload.topicName]: {
            authorName: payload.authorName,
            // imageUrl: payload.image_url,
                        image_url: payload.image_url,

            authId:payload.auth_id,
          },
        },
      };
    default:
      return state;
  }
}

